import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
export function SkipNavigation() {
  const {
    getThemeClasses
  } = useTheme();
  const themeClasses = getThemeClasses();
  return <a href="#main-content" className={`sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[9999] ${themeClasses.card} border ${themeClasses.border} px-4 py-2 rounded-lg ${themeClasses.text} font-medium shadow-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2`} data-id="element-1001">
      Skip to main content
    </a>;
}